var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { colors } from '../../../abstracts/colors';
import { getFontSize } from '../../../abstracts/typography';
export var ToastContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 4px;\n  color: ", ";\n  display: ", ";\n  flex-wrap: wrap;\n  font-size: ", ";\n  justify-content: space-between;\n  max-width: 425px;\n  padding-top: 0.75rem;\n"], ["\n  background-color: ", ";\n  border-radius: 4px;\n  color: ", ";\n  display: ", ";\n  flex-wrap: wrap;\n  font-size: ", ";\n  justify-content: space-between;\n  max-width: 425px;\n  padding-top: 0.75rem;\n"])), colors.black, colors.white, function (_a) {
    var isOpen = _a.isOpen;
    return (isOpen ? 'flex' : 'none');
}, getFontSize(1));
var templateObject_1;
